import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { FileSaverService } from 'ngx-filesaver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';



@Injectable({
  providedIn: 'root'
})
export class ExportService {

  constructor(private fs: FileSaverService) { }
  exportExcel(req: any) {
    const data: any[] = [];
    const cols = [...req.cols];
    const labels = [...req.label];
    if (cols.includes('action')) {
      cols.pop();
      labels.pop();
    }
    req.data.forEach((row: any, index: number) => {
      const obj: any = {};
      cols.forEach((col: string, i: number) => {
        const isMulti = req?.isDateMultiply ? true : false;
        obj[labels[i]] = col !== 'Sno' ? row[col] ? req?.dateField?.includes(col) ? moment(new Date((isMulti ? row[col] * 1000 : row[col]))).format('DD-MM-YYYY hh:mm a') : row[col] : '--' : index + 1
      });
      data.push(obj);
    });
    
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const buffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    this.fs.save(blob, req.filename + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
}
